(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("WaveSurfer"), require("videojs"));
	else if(typeof define === 'function' && define.amd)
		define("VideojsWavesurfer", ["WaveSurfer", "videojs"], factory);
	else if(typeof exports === 'object')
		exports["VideojsWavesurfer"] = factory(require("WaveSurfer"), require("videojs"));
	else
		root["VideojsWavesurfer"] = factory(root["WaveSurfer"], root["videojs"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_wavesurfer_js__, __WEBPACK_EXTERNAL_MODULE_video_js__) {
return 